module.exports = __webpack_public_path__ + "assets/img/title-2f374ab0.png";